module.exports = __webpack_public_path__ + "img/none.dc1ed24f.png";